import React, { useEffect, useState, Suspense, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PromoBanner } from './components/PromoBanner';
import { Hero } from './components/Hero';
import { GeoPriceContext, useGeoPriceLoader, useGeoPrice } from './hooks/useGeoPrice';
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const TruthSection = lazy(() => import('./components/TruthSection').then(m => ({
  default: m.TruthSection
})));
const SystemReveal = lazy(() => import('./components/SystemReveal').then(m => ({
  default: m.SystemReveal
})));
const OldSolutions = lazy(() => import('./components/OldSolutions').then(m => ({
  default: m.OldSolutions
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const WhoItsFor = lazy(() => import('./components/WhoItsFor').then(m => ({
  default: m.WhoItsFor
})));
const Results = lazy(() => import('./components/Results').then(m => ({
  default: m.Results
})));
const TripleYes = lazy(() => import('./components/TripleYes').then(m => ({
  default: m.TripleYes
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
function StickyMobileCTA() {
  const [show, setShow] = useState(false);
  const {
    symbol,
    offerPrice,
    label
  } = useGeoPrice();
  useEffect(() => {
    function handleScroll() {
      setShow(window.scrollY > window.innerHeight * 0.8);
    }
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-0">
      {show && <motion.div className="fixed bottom-0 left-0 right-0 z-40 md:hidden" initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} data-id="element-1">
          <div className="bg-dark-card border-t border-money/20 px-4 py-3" data-id="element-2">
            <a href="https://pay.hotmart.com/R104423897O" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full bg-gradient-to-r from-money-dark via-money to-emerald-400 text-white font-display font-extrabold text-base px-6 py-3.5 rounded-xl cta-pulse focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-money" data-id="element-3">
              🔥 Super Promo {symbol}
              {offerPrice} {label} — ¡Solo esta semana!
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
export function App() {
  const geoPrice = useGeoPriceLoader();
  return <GeoPriceContext.Provider value={geoPrice} data-id="element-4">
      <div className="w-full min-h-screen" data-id="element-5">
        <PromoBanner data-id="element-6" />
        <Hero data-id="element-7" />
        <Suspense fallback={null} data-id="element-8">
          <PainPoints data-id="element-9" />
          <TruthSection data-id="element-10" />
          <SystemReveal data-id="element-11" />
          <OldSolutions data-id="element-12" />
          <WhatYouGet data-id="element-13" />
          <WhoItsFor data-id="element-14" />
          <Results data-id="element-15" />
          <TripleYes data-id="element-16" />
          <Pricing data-id="element-17" />
        </Suspense>
        <StickyMobileCTA data-id="element-18" />
      </div>
    </GeoPriceContext.Provider>;
}